import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '@/presentation/components';
import { InteractiveButton } from '@/presentation/modules/procedures/components';
import iconExists from '../../../../../../../../assets/illustrations/exists-procedure.svg';
import iconWhatsapp from '../../../../../../../../assets/icons/icon-whatsapp-grey.svg';
import Link from '@/presentation/reusables/Link';

interface RectificationTeacherModalProps {
  handleClick: () => void;
}
const RectificationTeacherModal: React.FC<RectificationTeacherModalProps> = (
  props
) => {
  const { handleClick } = props;
  return (
    <Block
      customized
      maxWidth={isMobile ? '100%' : '496px'}
      backgroundColor="#fff"
      padding="0px 32px 32px 32px"
      margin="8px 0px 0px 0px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Block
        customized
        display="flex"
        justifyContent="center"
        alignItems="center"
        margin="0px 0px 16px"
      >
        <img src={iconExists} alt="error" />
      </Block>
      <Heading
        text={'La evaluación está en proceso de rectifcación por el docente'}
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <div
        style={{
          marginTop: 12,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <img
          src={iconWhatsapp}
          alt="whatsapp"
          style={{
            margin: 8,
            fill: '#000000'
          }}
        />
        <p>
          Para resolver tus dudas escríbenos al:{' '}
          <Link
            linkType="external"
            url="https://api.whatsapp.com/send?phone=51960252970&text=Hola,%20tengo%20una%20consulta"
            linkName="960 252 970"
          />
        </p>
      </div>
      <InteractiveButton
        data-testid="pse-go-progress"
        bkgColorEnabled="#5B36F2"
        bkgColorHover="#745EF6"
        bkgColorFocus="#4318CD"
        bkgColorPressed="#4318CD"
        customized
        as="button"
        alignItems="center"
        backgroundColor="#5B36F2"
        padding="10px 16px"
        borderRadius="4px"
        margin="40px 0px 0px 0px"
        width={isMobile ? '100%' : '97px'}
        onClick={() => handleClick()}
      >
        <Text
          color="#FFFFFF"
          fontSize="14px"
          lineHeight="20px"
          fontWeight="700"
          textAlign="center"
        >
          Entendido
        </Text>
      </InteractiveButton>
    </Block>
  );
};

export default RectificationTeacherModal;
